module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general-avaliability"
  }, [_vm._l((_vm.freeRooms), function(room, indexDay) {
    return _c('div', {
      key: indexDay,
      class: [
        'col-calendar',
        'col-calendar-1',
        _vm.ceroValue(room.free) ? 'red-value' : null ],
      on: {
        "click": function($event) {
          _vm.selectedDate(indexDay, _vm.flagActiveDate)
        }
      }
    }, [_c('p', {
      class: [
        'avaliability-date',
        _vm.firstDateSelected(indexDay) ? 'highlight-date' : null,
        _vm.rangeSelected(indexDay, _vm.rangeDate) ? 'highlight-date' : null,
        _vm.initRangeDate(indexDay, _vm.rangeDate) ? 'border-radius-left' : null,
        _vm.endRangeDate(indexDay, _vm.rangeDate) ? 'border-radius-right' : null ]
    }, [_vm._v("\n\t\t\t" + _vm._s(room.availabilities) + "\n\t\t")])])
  }), _vm._v(" "), (_vm.showAvaliabilityModal) ? _c('avaliability-modal', {
    attrs: {
      "calculate-position": _vm.rangeDate[0],
      "rooms-type": _vm.typesRooms,
      "init-date": _vm.initDate,
      "end-date": _vm.endDate,
      "total-nights": _vm.totalNights,
      "is-loading": _vm.isLoading,
      "subsidiary": _vm.subsidiaryId
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83a1514c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/calendar/subComponents/GeneralAvailability.vue
// module id = 1679
// module chunks = 24